/**
 * Warning marker — appears before the avatar on an interviewer chip
 * whose Google/Outlook calendar isn't connected. On hover, shows the
 * same short tooltip copy as legacy KInterviewScheduler so recruiters
 * understand why that user's busy events won't render on the calendar.
 */
import { Flex } from '@chakra-ui/react';
import { CalendarClose, FaceSad } from '@kula-ai/icons-core';
import {
  Text,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@kula-ai/components';

interface InterviewerCalNotConnectedProps {
  size?: number;
  /** CSS colour for the icon (e.g. `var(--kula-colors-error-200)` on the
   *  error-state chip). Defaults to the neutral secondary tone. */
  color?: string;
}

export function InterviewerCalNotConnected({
  size = 18,
  color = 'var(--kula-colors-secondary-700)',
}: InterviewerCalNotConnectedProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            style={{ display: 'inline-flex' }}
            onClick={(e) => e.stopPropagation()}
          >
            <CalendarClose size={size} color={color} />
          </span>
        </TooltipTrigger>
        <TooltipContent variant="light" side="top">
          <Flex align="center" gap="6px">
            <FaceSad size={18} color="var(--kula-colors-secondary-700)" />
            <Text variant="caption" color="heading">
              Calendar not connected. Events not visible.
            </Text>
          </Flex>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
